import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { TimecardSequence } from './timecard-sequence.model';

export const entityName = 'TimecardSequence';

@Injectable()
export class TimecardSequenceDataService extends EfaactDataService<TimecardSequence> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    // protected save(
    //     update: Update<TimecardSequence>
    // ): Observable<TimecardSequence> {
    //     this.log.verbose({
    //         type: `${this.entityName}DataService(TimecardSequenceDataService):save`,
    //         update
    //     });
    //     const item = {
    //         ...update.changes
    //     } as any;
    //     delete item.original;
    //     return this.http
    //         .put<IGenericResponse<TimecardSequence>>(this.entitiesUrl, {
    //             [`${this.entityName}List`]: [item]
    //         })
    //         .pipe(
    //             map(resp => {
    //                 this.log.verbose({
    //                     type: `${this.entityName}DataService(TimecardSequenceDataService):save:resp`,
    //                     resp
    //                 });
    //                 if (!fromShared.Errors.IsSuccessStatus(resp.StatusCode)) {
    //                     this.store.dispatch(
    //                         new fromShared.Errors.SetErrors(
    //                             fromShared.Errors.MapErrorsToStatus({
    //                                 ...resp,
    //                                 Items: resp.Items.filter(x => !!x).map(
    //                                     x => ({
    //                                         ...x,
    //                                         Status: {
    //                                             ...x.Status,
    //                                             MsgEntityID:
    //                                                 update.changes.original &&
    //                                                 update.changes.original.id
    //                                         }
    //                                     })
    //                                 )
    //                             })
    //                         )
    //                     );
    //                     throwError(
    //                         new DataServiceError(
    //                             fromShared.Errors.getResponseErrors(
    //                                 resp
    //                             ).reduce(
    //                                 (a, c, i) => (i === 0 ? c : `${a}\n${c}`),
    //                                 ''
    //                             ),
    //                             { method: 'PUT', url: this.entitiesUrl }
    //                         )
    //                     );
    //                     // throw new Error(
    //                     //     resp.ErrorMessages.reduce(
    //                     //         (a, c, i) => (i === 0 ? c : `${a}\n${c}`),
    //                     //         ''
    //                     //     )
    //                     // );
    //                     return {
    //                         // ...this.mapT(update.changes as T),
    //                         ...update.changes.original,
    //                         Status:
    //                             resp.Items[0] && resp.Items[0].Status
    //                                 ? resp.Items[0].Status
    //                                 : {
    //                                       StatusCode: resp.StatusCode,
    //                                       Message: resp.StatusType
    //                                   }
    //                     } as TimecardSequence;
    //                 }
    //                 const af = new EntityActionFactory();
    //                 // if (update.changes.SyncPayrollItems === true) {
    //                 this.store.dispatch(
    //                     af.create(
    //                         this.entityName,
    //                         EntityOp.SAVE_UPSERT_MANY_SUCCESS,
    //                         resp.Items.map(x => ({
    //                             ...this.mapItems(x)
    //                         }))
    //                     )
    //                 );
    //                 // }
    //                 return {
    //                     ...this.mapItems(resp.Items[0])
    //                     // Status: {
    //                     //     StatusCode: ResponseStatus.Success,
    //                     //     Message: 'Saved'
    //                     // }
    //                 } as TimecardSequence;
    //             }),
    //             catchError((e, c) =>
    //                 fromShared.Errors.handleDataServiceError(this.store, e, c)
    //             )
    //         );
    // }

    mapItems(item: TimecardSequence): TimecardSequence {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.Empauthid,
            Tasksortorder: item.Tasksortorder
        };
    }
}
